import React from "react";

interface CardProps {
    number?: string;
    title: string;
    description: string;
}

interface StepCardProps {
    cards: CardProps[];
    title?: string;
    description?: string;
    sectionStyle?: React.CSSProperties;
    cardstyle?: React.CSSProperties;
    headerCaption?: string;
}

const StepCard: React.FC<StepCardProps> = ({ cards, title = "How It Works", description, sectionStyle, cardstyle, headerCaption }) => {
    return (
        <div className="bg-blue-100 flex-col gap-2 py-2 lg:py-8" style={sectionStyle}>
            {headerCaption && (
                <p className="text-center my-2 text-sm uppercase font-bold" style={{ color: "rgba(51, 100, 250, 1)" }}>
                    {headerCaption}
                </p>
            )}
            <h2 className="text-center text-4xl lg:text-5xl">{title}</h2>
            {description && <p className="text-center mt-2 text-md">{description}</p>}
            <div className="lg:flex lg:flex-col items-center hidden py-5">
                <div className="flex gap-12 mx-64">
                    {cards.map((card, index) => (
                        <div key={index} className="flex-col items-center justify-center space-y-2 p-2 flex-1">
                            <div
                                className="text-center w-32 h-32 flex mb-8 items-center justify-center justify-self-center text-8xl font-bold"
                                style={{ borderRadius: "32px", color: cardstyle?.color || "#3364DA", backgroundColor: cardstyle?.backgroundColor || "#fff" }}
                            >
                                {card?.number || index + 1}
                            </div>
                            <h6 className="text-center">{card.title}</h6>
                            <p className="text-center flex-wrap text-base">{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex lg:hidden mt-5">
                <div className="flex-col gap-3 mx-4">
                    {cards.map((card, index) => (
                        <div key={index} className="mb-4 flex items-center">
                            <div
                                className="text-center w-12 h-12 flex items-center justify-center justify-self-center text-2xl bg-white font-bold"
                                style={{ borderRadius: "12px", color: "#3364DA" }}
                            >
                                {card?.number || index + 1}
                            </div>
                            <div className="ml-2">
                                <h6 className="text-left text-sm">{card.title}</h6>
                                <p className="text-left flex-wrap text-xs">{card.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StepCard;
